import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var OpenStreetMap =
/*#__PURE__*/
function () {
  function OpenStreetMap(options) {
    _classCallCheck(this, OpenStreetMap);

    //Bounds are expected to be a nested array of [[sw_lat, sw_lng],[ne_lat, ne_lng]].
    // We convert them into a string of 'x1,y1,x2,y2' which is the opposite way around from lat/lng - it's lng/lat
    var boundsUrlComponent = "";
    var regionUrlComponent = "";

    if (options && options.searchBounds && options.searchBounds.length) {
      var reversedBounds = options.searchBounds.reduce(function (acc, b) {
        return [].concat(_toConsumableArray(acc), [b.lng, b.lat]);
      }, []);
      boundsUrlComponent = "&bounded=1&viewbox=".concat(reversedBounds.join(","));
    }

    if (options && "region" in options) {
      regionUrlComponent = "&countrycodes=".concat(options.region);
    }

    this.url = "https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&polygon_svg=1&namedetails=1".concat(boundsUrlComponent).concat(regionUrlComponent, "&q=");
  }

  _createClass(OpenStreetMap, [{
    key: "search",
    value: function search(query) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var rawResponse, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch(this.url + query);

              case 2:
                rawResponse = _context.sent;
                _context.next = 5;
                return rawResponse.json();

              case 5:
                response = _context.sent;
                return _context.abrupt("return", this.formatResponse(response));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "formatResponse",
    value: function formatResponse(response) {
      var resources = response;
      var count = response.length;
      var info = count > 0 ? resources.map(function (e) {
        return {
          bounds: e.boundingbox.map(function (bound) {
            return Number(bound);
          }),
          latitude: Number(e.lat),
          longitude: Number(e.lon),
          name: e.display_name
        };
      }) : "Not Found";
      return {
        info: info,
        raw: response
      };
    }
  }]);

  return OpenStreetMap;
}();

export { OpenStreetMap };